export const contentfulAssetFragment = /* GraphQL */ `
  fragment contentfulAsset on Asset {
    url(locale: $locale)
    title(locale: $locale)
    description(locale: $locale)
  }
`
